// https://www.npmjs.com/package/google-maps

export default class LocationMap {
	wrapper: HTMLElement;
	mapData: any;

	mapCenter: any;
	markerCenter: any;

	googleLoader: any;
	google: any;
	map: any;

	constructor() {
		if(document.getElementById("location-map-wrapper")) {
			this.wrapper = <HTMLElement> document.getElementById("location-map-wrapper");

			this.googleLoader = require('google-maps');
			this.googleLoader.KEY = 'AIzaSyAi8vMhyMIPmIOBLYR-s_10bBVxWoo2ZFo';

			this.googleLoader.LIBRARIES = ['places'];

			this.googleLoader.load((google) => {
				this.google = google; // Store the google library for future reference

				this.initMap(); // Create the map
			});
		}
	}

	initMap() {
		let mapEl = document.getElementById('location-map');
		if(mapEl) {
			let mapDataEl = document.getElementById('location-map-data');
			this.mapData = JSON.parse(mapDataEl.innerHTML);

			if (window.innerWidth >= 768 && this.wrapper.getAttribute("data-page") === "front") {
				this.mapCenter = {lat: parseFloat(this.mapData.lat), lng: parseFloat(this.mapData.lng) + 0.001};
			} else {
				this.mapCenter = {lat: parseFloat(this.mapData.lat), lng: parseFloat(this.mapData.lng)};
			}
			this.markerCenter = {lat: parseFloat(this.mapData.lat), lng: parseFloat(this.mapData.lng)};
			this.map = new this.google.maps.Map(mapEl, {
				center: this.mapCenter,
				zoom: 18,

				scrollwheel: false,
				// draggable: false,
				scaleControl: false,
				mapTypeControl: false,
				navigationControl: false
			});

			var markerImage = {
				url: this.mapData.marker_img,
				size: new this.google.maps.Size(186, 186),
				origin: new this.google.maps.Point(0, 0),
				anchor: new this.google.maps.Point(93, 93)
			};

			var marker = new this.google.maps.Marker({
				position: this.markerCenter,
				icon: markerImage,
				map: this.map
			});
		}
	}
}